import { render } from "./BigNote.vue?vue&type=template&id=82a1bbc2&scoped=true"
import script from "./BigNote.vue?vue&type=script&lang=js"
export * from "./BigNote.vue?vue&type=script&lang=js"

import "./BigNote.vue?vue&type=style&index=0&id=82a1bbc2&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82a1bbc2"]])

export default __exports__